import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { canViewAccounting } from '../../../utils/RoutingUtils';
import { Row, Col } from 'react-bootstrap';
import Select from '../../components/Select.js';
import { addBusiness } from '../../../actions/BusinessInformationActions.js';
import { businessInformationFields } from '../../../config/Fields';
import { showToast } from '../../../actions/Actions.js';
import { US_STATES } from '../../../config/Constants';
import '../../../css/AccountingForm.css';

const entity_type = [
    { label: 'Sole Proprietorship', value: 'SOLE_PROP' },
    { label: 'C Corporation', value: 'C_CORP' },
    { label: 'Limited Liability Company', value: 'LLC' },
    { label: 'S Corporation', value: 'S_CORP' },
    { label: 'Partnership', value: 'PARTNERSHIP' },
];

class AccountingForm extends Component {
    constructor(props) {
        super(props);
        const { accountId } = this.props;
        this.state = {
            legalCompanyNameInvalidMsg: '',
            taxIdentificationNumberInvalidMsg: '',
            state: '',
            account_id: accountId,
            legal_name: '',
            company_type: '',
            tax_id: '',
        };
    }

    constructbusinessInformation = () => {
        const data = {};
        const dataFields = businessInformationFields;
        dataFields.forEach(field => {
            if (field in this.state) {
                data[field] = this.state[field];
            }
        });
        return data;
    };

    requiredFieldsAndCheckFunctions = {
        legal_name: () => this.state.legal_name !== '',
        state: () => this.state.state !== '',
        company_type: () => this.state.company_type !== '',
    };

    checkIfRequiredFieldsAreValid = () => {
        const requiredFields = Object.keys(this.requiredFieldsAndCheckFunctions);
        const notValid = requiredFields.some(field => {
            if (this.state[field] === '') {
                this.props.showToast(
                    'Make sure all mandatory fields are filled out correctly',
                    'warning'
                );
                return true;
            }
            if (!this.requiredFieldsAndCheckFunctions[field]()) {
                return true;
            }
            return false;
        });
        return !notValid;
    };

    saveBussinessInformation = event => {
        event.preventDefault();
        if (!this.checkIfRequiredFieldsAreValid()) {
            return;
        }
        this.setState({ loading: true });

        const businessInformationData = this.constructbusinessInformation();
        this.props.addBusiness(businessInformationData, newBusinessInfomration => {
            if (newBusinessInfomration === false) {
                this.setState({ spinner_loader: false });
                return;
            }
            this.props.showToast(
                `Business Information updated for embedded accounting`,
                'positive'
            );
        });
    };

    handleLegalCompanyNameOnChange = newName => {
        this.setState({ legal_name: newName.target.value });
    };

    handleTaxIdentificationNumberOnChange = newTaxIdentificationNumber => {
        this.setState({ tax_id: newTaxIdentificationNumber.target.value });
    };
    handleUsStateOnChange = newUsState => {
        this.setState({ state: newUsState }); // Uses listOption - dont use .target.value
    };

    handleEntityTypeOnChange = newEntityType => {
        this.setState({ company_type: newEntityType }); // Uses listOption - dont use .target.value
    };

    setFields = fields => {
        this.setState({ ...fields });
    };

    render() {
        const { pathname } = this.props.history.location;
        const { legal_name, tax_id, company_type, state } = this.state;

        return (
            <>
                <div className="secondaryNav">
                    {canViewAccounting && (
                        <button
                            className={classNames({
                                secondaryNavLink: true,
                                secondaryNavActiveLink: pathname === '/accounting',
                            })}
                            onClick={() => this.props.history.push('accounting')}
                        >
                            Accounting Form
                        </button>
                    )}
                </div>

                <div className="ftContainer cardContainer accountingForm">
                    <form className="ftForm" onSubmit={this.saveBussinessInformation}>
                        <Row>
                            <div className="logoContainer">
                                <img
                                    style={{ width: 120, height: 35 }}
                                    srcSet="/img/sales/logo@2x-dark.png "
                                    src="/img/sales/logo@2x-dark.png"
                                    alt="Minute7"
                                />
                            </div>
                        </Row>
                        <Row className="ftRowAlightCenter ftRowMarginBottom">
                            <div className="ftSubHeader">Minute7 embedded accounting system</div>
                        </Row>
                        <Row className="ftrow">
                            <Col sm={6} style={{ marginBottom: '5px' }}>
                                <div className="ftLabelAndInput">
                                    <Row>
                                        <div className="ftLabel largeBodyText greyText">
                                            {' '}
                                            Legal Company Name <span className="required">*</span>
                                        </div>
                                    </Row>

                                    <div>
                                        <Input
                                            className={
                                                this.state.legalCompanyNameInvalidMsg === ''
                                                    ? 'accountingFormInputs'
                                                    : 'ausInvalidInput'
                                            }
                                            name="legal_company_name"
                                            value={legal_name}
                                            onChange={this.handleLegalCompanyNameOnChange}
                                        />
                                        <div className="ftInputError">
                                            {!this.state.legal_company_nameMsg === '' &&
                                            !legal_name === '' ? (
                                                <label />
                                            ) : (
                                                <label className="error-message">
                                                    {this.state.legalCompanyNameInvalidMsg}
                                                </label>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col sm={6} style={{ marginBottom: '5px' }}>
                                <div className="ftLabelAndInput">
                                    <Row>
                                        <div className="ftLabel largeBodyText greyText">
                                            {' '}
                                            Tax Identification Number{' '}
                                        </div>
                                    </Row>
                                    <div>
                                        <Input
                                            className={
                                                this.state.taxIdentificationNumberInvalidMsg === ''
                                                    ? 'accountingFormInputs'
                                                    : 'ausInvalidInput'
                                            }
                                            name="tax_identification_number"
                                            value={tax_id}
                                            onChange={this.handleTaxIdentificationNumberOnChange}
                                        />
                                        <div className="ftInputError">
                                            {!this.state.taxIdentificationNumberInvalidMsg === '' &&
                                            !tax_id === '' ? (
                                                <label />
                                            ) : (
                                                <label className="error-message">
                                                    {this.state.taxIdentificationNumberInvalidMsg}
                                                </label>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                        <Row className="ftrow">
                            <Col sm={6} style={{ marginBottom: '5px' }}>
                                <div className="ftLabelAndInput">
                                    <Row>
                                        <div className="ftLabel largeBodyText greyText">
                                            {' '}
                                            US State
                                        </div>
                                        <div className="required">*</div>
                                    </Row>
                                    <div className="ftDropdown">
                                        <Select
                                            options={US_STATES}
                                            valueForOption={option => option.value}
                                            labelForOption={option => option.label}
                                            value={state}
                                            onChange={this.handleUsStateOnChange}
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col sm={6} style={{ marginBottom: '5px' }}>
                                <div className="ftLabelAndInput">
                                    <Row>
                                        <div className="ftLabel largeBodyText greyText">
                                            {' '}
                                            Entity Type
                                        </div>
                                        <div className="required">*</div>
                                    </Row>
                                    <div className="ftDropdown">
                                        <Select
                                            options={entity_type}
                                            valueForOption={option => option.value}
                                            labelForOption={option => option.label}
                                            value={company_type}
                                            onChange={this.handleEntityTypeOnChange}
                                        />
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row>
                            <div className="ftButtonContainer">
                                <button
                                    type="submit"
                                    className="primaryButton ftButton ftButtonHeight"
                                >
                                    Register for Accounting
                                </button>
                            </div>
                        </Row>
                    </form>
                </div>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        legalCompanyNameInvalidMsg: state.legalCompanyNameInvalidMsg,
        taxIdentificationNumberInvalidMsg: state.taxIdentificationNumberInvalidMsg,
        state: state.state,
        label: state.label,
        accountId: state.accountStore.id,
        legal_name: state.legal_name,
        tax_id: state.tax_id,
        company_type: state.company_type,
    };
}

const mapDispatchToProps = {
    addBusiness,
    showToast,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AccountingForm);
